

import { testNet } from '@fluencelabs/fluence-network-environment';

export const fluentPadServiceId = 'fluence/fluent-pad';

export const notifyOnlineFnName = 'notifyOnline';
export const notifyUserAddedFnName = 'notifyUserAdded';
export const notifyUserRemovedFnName = 'notifyUserRemoved';
export const notifyTextUpdateFnName = 'notifyTextUpdate';

export const historyServiceId = '64ea579e-b863-4a42-b80c-e7b5ec1ab7fa';
export const userListServiceId = '91041afe-0c3c-451a-9003-6bb92a570aae';

export const userListNodePeerId = testNet[3].peerId;
export const historyNodePeerId = testNet[3].peerId;

export const relayNode = testNet[0];
